"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrunkenClarityAbilityHandler = exports.DrunkenClarityActorAbilityFactory = exports.DrunkenClarityAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const enums_1 = require("../../core/enums");
const core_2 = require("../../core/effects/core");
const Enum_1 = require("../../utils/Enum");
class DrunkenClarityAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.DrunkenClarity;
        this.__typeName = "DrunkenClarity";
    }
}
exports.DrunkenClarityAbilityArgs = DrunkenClarityAbilityArgs;
let DrunkenClarityActorAbilityFactory = class DrunkenClarityActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("DrunkenClarity", "AllAllies", 4);
    }
};
DrunkenClarityActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("DrunkenClarity")
], DrunkenClarityActorAbilityFactory);
exports.DrunkenClarityActorAbilityFactory = DrunkenClarityActorAbilityFactory;
let DrunkenClarityAbilityHandler = class DrunkenClarityAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [focus, power] = container.getAttributeScores(ability.invokerId, [
            "Focus",
            "Power"
        ]);
        const focusOrPower = focus > power ? "Focus"
            : "Power";
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
                    .forEach(allyId => {
                    container.applyBuff({
                        sequence,
                        creatorId: ability.invokerId,
                        targetId: allyId,
                        duration: Duration_1.Duration.Turns(4),
                        effect: new core_2.LinkedEffectsEffectArgs([
                            new core_2.MaxAttributeIncreaseEffectArgs((0, Enum_1.enumValue)(enums_1.AttributeType, focusOrPower), container.getPercentOfBaseAttributeScore(allyId, 10, focusOrPower)),
                            new core_2.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Will, container.getPercentOfBaseAttributeScore(allyId, 10, "Will")),
                        ], false),
                        onApplied: (sequence) => {
                            sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(allyId, "head"), "FaintYellowGreenCircleDispersion"));
                        }
                    });
                });
            }
        });
    }
};
DrunkenClarityAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.DrunkenClarity)
], DrunkenClarityAbilityHandler);
exports.DrunkenClarityAbilityHandler = DrunkenClarityAbilityHandler;
